import React, { Component } from "react";
import Modal from "../boxes/Modal";
import { useTranslation, withTranslation } from "react-i18next";
import { formatProductName } from "../../utils/helpers";

class ProductsModal extends Component {
  render() {
    const { onClose, unassignedProducts, selectUnassignedProduct, isFrozen, t } =
      this.props;

    // Invoice-ahead freeze: block product selection.
    if (isFrozen) {
      return (
        <Modal title={t("productsListModalTitle")} onClose={onClose}>
          <div className="unassigned-prod-modal-wrap">
            <p className="unassigned-prod-modal-wrap__small-text">
              {t("freezeMessage")}
            </p>
          </div>
        </Modal>
      );
    }

    return (
      <Modal title={t("productsListModalTitle")} onClose={onClose}>
        <div className="unassigned-prod-modal-wrap">
          {unassignedProducts.length > 0 ? (
            unassignedProducts.map((product) => (
              <div
                key={product.id}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ margin: "1rem 2rem" }}>
                  <h3 className="dashboard-card__title-text">{formatProductName(product.name)}</h3>
                  <p className="unassigned-prod-modal-wrap__small-text">
                    {t("countedAvailableSlots", {
                      slot: product.available_slots,
                    })}
                  </p>
                </div>

                <button
                  style={{ marginLeft: "2rem" }}
                  onClick={() => selectUnassignedProduct(product)}
                  className="dashboard__primary-btn"
                >
                  {t("select", { ns: "common" })}
                </button>
              </div>
            ))
          ) : (
            <p className="unassigned-prod-modal-wrap__small-text">
              {t("slotsUsedUpMessage")}
            </p>
          )}
        </div>
      </Modal>
    );
  }
}

const ProductsModalWithTranslation = withTranslation(["profile"])(
  ProductsModal
);
export default ProductsModalWithTranslation;
